<template>
  <section class="easyTable" ref="easyTable">
    <el-table
      :data="aList"
      stripe
      style="width: 100%"
      v-loading="bLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      class="stripeTable"
      :row-key="rowKey"
      @selection-change="
        payload => {
          $emit('selection-change', payload)
        }
      "
      :height="height"
    >
      <slot name="first"></slot>
      <el-table-column
        :key="prop.toString()"
        :formatter="(row, column) => formatter(row, column, prop)"
        :label="label"
        :align="align ? align : 'left'"
        show-overflow-tooltip
        v-for="{ prop, label, align } in config"
      >
      </el-table-column>
      <slot name="last"></slot>
    </el-table>

    <div class="footer">
      <el-pagination
        v-show="!hidePagination"
        layout="prev, pager, next"
        :current-page="nPageNum"
        @current-change="handleCurrentChange"
        :total="nTotal"
      >
      </el-pagination>
    </div>
  </section>
</template>

<script>
  // 文档 https://www.showdoc.cc/ZXG?page_id=2727746022715653 密码000000
  import { showClass } from 'utils'
  import { Loading } from 'element-ui'
  import * as api from '../APIResultFomate.json'
  export default {
    props: {
      apiUrl: {
        type: String
      },
      pData: {
        type: Object
      },
      config: {
        type: Array
      },
      other: {
        type: Object
      },
      rowKey: {
        type: String
      },
      hidePagination: {
        type: Boolean,
        default: false
      },
      height: {
        type: Number,
        default: 470
      },
      methods: {
        type: String,
        default: 'get'
      }
    },
    data() {
      return {
        bLoading: true,
        aList: [],
        nPageNum: 1,
        nPageSize: 10,
        nTotal: 0,
        /*request*/
        sPageNum: 'pageNum',
        sPageSize: 'pageSize',
        /*response*/
        sList: '',
        sTotal: 'total'
      }
    },
    methods: {
      formatter(row, column, prop) {
        if (showClass(prop) == 'Function') {
          return prop(row, column)
        } else if (showClass(prop) == 'String') {
          let value = row
          prop.split('.').forEach(p => {
            value = value[p]
          })
          return value
        }
      },
      pageToOne() {
        this.nPageNum = 1
      },
      getData(pageNo) {
        this.nPageNum = pageNo || 1
        if (!this.apiUrl) {
          this.aList = this.pData.data
          this.nTotal = this.pData ? this.pData.nTotal : 0
          if (!this.hidePagination) {
            this.$nextTick(this.changePage)
          }
          this.bLoading = false
          return
        }
        let that = this
        that.bLoading = true
        console.log(this.other,'this.other');
        
        if (this.methods == 'get') {
          this.$axiosget(this.apiUrl, {
            params: {
              [that.sPageNum]: that.nPageNum,
              [that.sPageSize]: that.nPageSize,
              sorted: 0,
              ...that.other
            }
          }).then(
            res => {
              that.aList = that.dataUrl(res)[that.sList || 'list'] || res.data.data
              that.nTotal = that.dataUrl(res)[that.sTotal] || 0
              that.bLoading = false
            },
            error => {
              that.bLoading = false
            }
          )
        } else {
          this.$axiospost(this.apiUrl, {
            [that.sPageNum]: that.nPageNum,
            [that.sPageSize]: that.nPageSize,
            ...that.other
          }).then(
            res => {
              that.aList = that.dataUrl(res)[that.sList || 'list'] || res.data.data
              that.nTotal = that.dataUrl(res)[that.sTotal] || 0
              that.bLoading = false
            },
            error => {
              that.bLoading = false
            }
          )
        }
      },
      changePage() {
        let [pageSize, currentPage] = [this.nPageSize, this.nPageNum]
        let min = pageSize * (currentPage - 1)
        let max = min + pageSize - 1
        let All = Array.from(
          this.$refs['easyTable'].querySelector('tbody').querySelectorAll('.el-table__row')
        )
        All.forEach((row, i) => {
          row.style.display = i + 1 > min && i - 1 < max ? '' : 'none'
        })
        this.$emit('changePage', {
          pageSize,
          currentPage
        })
      },
      handleSizeChange(pageSize) {
        this.nPageSize = pageSize
        if (!this.apiUrl) {
          this.changePage()
        } else {
          this.getData()
        }
      },
      handleCurrentChange(currentPage) {
        if (!this.apiUrl) {
          this.changePage()
        } else {
          this.getData(currentPage)
        }
      }
    },
    mounted() {
      for (var config in api[this.apiUrl]) this[config] = api[this.apiUrl][config]
      this.getData()
    },
    watch: {
      apiUrl() {
        this.bLoading = true
        this.aList = []
        this.nPageNum = 1
        this.nPageSize = 10
        this.nTotal = 0
        for (var config in api[this.apiUrl]) this[config] = api[this.apiUrl][config]
        this.getData()
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/public/easyTable/index.vue